export default [
  {
    path: "/ElectronicContract/ElectronicContract",
    name: "ElectronicContract",
    component: () =>
      import("@/views/pages/Systems/ElectronicContract/ElectronicContract.vue"),
    props: true,
    meta: {
      pageTitle: "電子合約",
      breadcrumb: [
        {
          text: "電子合約",
        },
      ],
    },
  },
  {
    path: "/ElectronicContract/AgreementManagement",
    name: "AgreementManagement",
    component: () =>
      import(
        "@/views/pages/Systems/ElectronicContract/AgreementManagement/AgreementManagement.vue"
      ),
    props: true,
    meta: {
      pageTitle: "其他約定事項",
      breadcrumb: [
        {
          text: "其他約定事項",
        },
      ],
    },
  },
  {
    path: "/ElectronicContract/ElecFormDownload",
    name: "ElecFormDownload",
    component: () =>
      import("@/views/pages/Systems/ElectronicContract/ElecFormDownload.vue"),
    props: true,
    meta: {
      pageTitle: "電子合約相關表單列印",
      breadcrumb: [
        {
          text: "電子合約相關表單列印",
        },
      ],
    },
  },
];
